import axios from "axios";
import { getToken } from "./storage";
import { store } from "../index";
import {
  START_LOADER_T1,
  STOP_LOADER_T1,
  TOAST_ERROR,
} from "Constants/actionConstants";
import { logOutWithToken } from "./api";

const axiosT1 = axios.create({
  baseURL: process.env.BASE_URL,
  //   timeout: 10000,
  headers: {
    token: getToken(),
  },
});

axiosT1.interceptors.request.use(
  (config) => {
    // console.log("config:", config);
    store.dispatch({ type: START_LOADER_T1 });
    return config;
  },
  (error) => {
    console.log("error:", error);
    store.dispatch({ type: STOP_LOADER_T1 });
    store.dispatch({
      type: TOAST_ERROR,
      message:
        error && error.message ? error.message : "Oops! Something Went Wrong",
    });

    return Promise.reject(error);
  }
);

axiosT1.interceptors.response.use(
  (response) => {
    // console.log("response:", response);
    store.dispatch({ type: STOP_LOADER_T1 });
    if (response.status === 401) {
      logOutWithToken();
    }
    return response;
  },
  (error) => {
    console.log("error:", error);
    store.dispatch({ type: STOP_LOADER_T1 });
    store.dispatch({
      type: TOAST_ERROR,
      message:
        error && error.message ? error.message : "Oops! Something Went Wrong",
    });
    return Promise.reject(error);
  }
);

export default axiosT1;
